import React, { useState } from 'react';
import { FAQ_ITEMS } from '../../data/constants';
import './FAQ.css';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" style={{ background: 'var(--dark)' }}>
      <div className="faq-layout">
        <div className="faq-sidebar">
          <div className="section-label">FAQ</div>
          <h2 className="section-title">Preguntas<br /><em>frecuentes</em></h2>
          <p className="faq-sidebar-desc">
            Resolvemos las dudas más comunes de nuestros clientes. Si no encuentra la respuesta que busca, no dude en contactarnos.
          </p>
        </div>
        <div className="faq-list">
          {FAQ_ITEMS.map((item, i) => (
            <div className={`faq-item ${openIndex === i ? 'open' : ''}`} key={i}>
              <button className="faq-q" onClick={() => toggle(i)}>
                {item.question}
                <span className="faq-icon">+</span>
              </button>
              <div className="faq-a">{item.answer}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
